import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import '../styles/Rdashboard.css';

import CreateGatePassForm from '../../forms/createGatePassForm';
import CreateWorkPermitForm from '../../forms/createWorkPermitForm';

const QuickActions = ({ account, selectedProperty, unitOptions }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [showGatePassForm, setShowGatePassForm] = useState(false);
  const [showWorkPermitForm, setShowWorkPermitForm] = useState(false);

  const normalizedAccount = {
    accountId: account?.accountId || account?.id || account?._id || account?.userId || null,
    accountName: account?.accountName || account?.givenName || account?.name || 'Unknown',
    role: account?.role || 'resident',
  };

  const handleGatePassCreated = () => {
    queryClient.invalidateQueries(['requests', selectedProperty?.value]);
    setShowGatePassForm(false);
  };

  const handleWorkPermitCreated = () => {
    queryClient.invalidateQueries(['workPermits']);
    setShowWorkPermitForm(false);
  };

  useEffect(() => {
    console.log('unitOptions in QuickActions:', unitOptions);
  }, [unitOptions]);

  return (
    <div className="quick-actions w-full mt-4">
      <div className="grid grid-cols-2 gap-4 md:flex w-full">
        <button
          className="quick-action-button text-sm md:text-md flex-1 h-[90px] rounded-xl bg-[#818FB4] text-white font-semibold cursor-pointer transition-colors duration-200"
          onClick={() => navigate('/balance-transactions')}
        >
          Pay <br /> Dues
        </button>

        <button
          className="quick-action-button text-sm md:text-md flex-1 h-[90px] rounded-xl bg-[#818FB4] text-white font-semibold cursor-pointer transition-colors duration-200"
          onClick={() => setShowGatePassForm(true)}
        >
          File Gate <br /> Pass
        </button>

        <button
          className="quick-action-button text-sm md:text-md flex-1 h-[90px] rounded-xl bg-[#818FB4] text-white font-semibold cursor-pointer transition-colors duration-200"
          onClick={() => setShowWorkPermitForm(true)}
        >
          File Work <br /> Permit
        </button>

        <button
          className="quick-action-button text-sm md:text-md flex-1 h-[90px] rounded-xl bg-[#818FB4] text-white font-semibold cursor-pointer transition-colors duration-200"
          onClick={() => navigate('/requests/amenities')}
        >
          Book <br /> Amenity
        </button>
      </div>

      {showGatePassForm && (
        <CreateGatePassForm
          onClose={() => setShowGatePassForm(false)}
          account={normalizedAccount}
          property={{ _id: selectedProperty.value }}
          unitOptions={unitOptions}
          role={account.role}
          onRequestCreated={handleGatePassCreated}
        />
      )}

      {showWorkPermitForm && (
        <CreateWorkPermitForm
          onClose={() => setShowWorkPermitForm(false)}
          property={{ property: { _id: selectedProperty.value } }}
          propertyId={selectedProperty.value}
          onRequestCreated={handleWorkPermitCreated}
        />
      )}
    </div>
  );
};

export default QuickActions;
